import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { Flex } from '../../components';

const PageHeader = ({
  children,
  title,
  leftActions,
  rightActions,
  isTitleFirst,
  isSticky,
}) => (
  <Flex.V
    sx={
      isSticky
        ? {
            borderBottom: '1px solid #DDD',
            position: 'sticky',
            top: 64,
            zIndex: 100,
            backgroundColor: '#fff',
          }
        : {
            borderBottom: '1px solid #DDD',
            position: 'relative',
          }
    }
  >
    <Flex.H
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: `20px 20px ${children ? 8 : 20}px 20px`,
        gap: '20px',
      }}
    >
      {!isTitleFirst && leftActions}

      <Typography variant="h1" sx={{ whiteSpace: 'nowrap' }}>
        {title}
      </Typography>

      {isTitleFirst && leftActions}

      {rightActions}
    </Flex.H>

    <Flex.H sx={{ paddingLeft: '20px' }}>{children}</Flex.H>
  </Flex.V>
);

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  leftActions: PropTypes.element,
  rightActions: PropTypes.element,
  isTitleFirst: PropTypes.bool,
  isSticky: PropTypes.bool,
};

export default PageHeader;
